import React from 'react'
import { Box, Container, Flex, Highlight, IconButton, Image, SimpleGrid, Stack, Text } from '@chakra-ui/react'
import { useEffect } from 'react';
import { useContext } from 'react';
import { ThemeContext } from '../context/ThemeContext';
import AOS from 'aos'
import VanillaTilt from 'vanilla-tilt';
import 'aos/dist/aos.css'
import certificate from "../assets/img/achievements/Certiificate.png"
import star from "../assets/img/achievements/star.png"
import first from "../assets/img/achievements/first.jpg"
import { RiCodeSLine, RiLightbulbLine, RiUserVoiceLine } from 'react-icons/ri';
import { BiGitBranch } from 'react-icons/bi';
import { GiBrainDump } from 'react-icons/gi';
const Acheivements = () => {
    const { Theme } = useContext(ThemeContext)
    useEffect(() => {
        AOS.init();
    }, [])

    const options = {
        scale: 1.1,
        speed: 1000,
        max: 30
    };

    return (
        <Box className={`${Theme === 'dark' ? "newBackground2" : ""} `} minH={"full"} >
            <Container maxW={"100%"} pb="10" data-aos="fade-up" data-aos-duration="1000" centerContent >
                <Tilt1 options={options} Theme={Theme} />
                <SimpleGrid w={"90%"} m="auto" columns={[1, 1, 2, 3, 4]} spacing={10} >
                    <Flex pb="6" borderRadius={"10px"} className='acheivementBoxshadow' flexDir='column' alignItems={"center"} justifyContent={"center"} bg={"#fff"} >
                        <Image src={star} alt="90%" />
                        <Image src={certificate} w="90%" alt="" />
                        <Text>HackerRank</Text>
                    </Flex>

                    <Flex py="5" borderRadius={"10px"} className='acheivementBoxshadow' flexDir='column' alignItems={"center"} justifyContent={"center"} bg={"#fff"} >
                        <Flex flexDir='row' alignItems={"center"} justifyContent={"space-between"} w="90%" m="auto">
                            <IconButton
                                bg={Theme === "dark" ? "#F2AA4CFF" : "red.400"}
                                aria-label='Search database'
                                icon={<RiCodeSLine color={Theme !== "dark" ? "#fff" : "#000"} />}
                            />
                            <Text w="70%" >1200+ Hours Practical Coding</Text>
                        </Flex>
                        <Flex flexDir='row' alignItems={"center"} justifyContent={"space-between"} w="90%" m="auto">
                            <IconButton
                                bg={Theme === "dark" ? "#F2AA4CFF" : "red.400"}
                                aria-label='Search database'
                                icon={<RiLightbulbLine color={Theme !== "dark" ? "#fff" : "#000"} />}
                            />
                            <Text w="70%">500+ Hours Data Structures & Algorithm</Text>
                        </Flex>
                        <Flex flexDir='row' alignItems={"center"} justifyContent={"space-between"} w="90%" m="auto">
                            <IconButton
                                bg={Theme === "dark" ? "#F2AA4CFF" : "red.400"}
                                aria-label='Search database'
                                icon={<RiUserVoiceLine color={Theme !== "dark" ? "#fff" : "#000"} />}
                            />
                            <Text w="70%">100+ Hours Soft Skill Development</Text>
                        </Flex>
                    </Flex>

                    <Flex py="5" borderRadius={"10px"} className='acheivementBoxshadow' flexDir='column' alignItems={"center"} justifyContent={"center"} bg={"#fff"} >
                        <Flex flexDir='row' alignItems={"center"} justifyContent={"space-between"} w="90%" m="auto">
                            <IconButton
                                bg={Theme === "dark" ? "#F2AA4CFF" : "red.400"}
                                aria-label='Search database'
                                icon={<GiBrainDump color={Theme !== "dark" ? "#fff" : "#000"} />}
                            />
                            <Text w="70%" >50+ Mini Projects</Text>
                        </Flex>
                        <Flex flexDir='row' alignItems={"center"} justifyContent={"space-between"} w="90%" m="auto">
                            <IconButton
                                bg={Theme === "dark" ? "#F2AA4CFF" : "red.400"}
                                aria-label='Search database'
                                icon={<RiCodeSLine color={Theme !== "dark" ? "#fff" : "#000"} />}
                            />
                            <Text w="70%">10+ Major Projects</Text>
                        </Flex>
                        <Flex flexDir='row' alignItems={"center"} justifyContent={"space-between"} w="90%" m="auto">
                            <IconButton
                                bg={Theme === "dark" ? "#F2AA4CFF" : "red.400"}
                                aria-label='Search database'
                                icon={<BiGitBranch color={Theme !== "dark" ? "#fff" : "#000"} />}
                            />
                            <Text w="70%">1000+ Git Commits</Text>
                        </Flex>
                    </Flex>

                    <Flex px="3" pt="5" pb="-5" borderRadius={"10px"} className='acheivementBoxshadow' flexDir='column' alignItems={"center"} justifyContent={"center"} bg={"#fff"} >
                        <Text fontSize={"12"}>
                            My team and i secured first rank in project competion, came first in Masai School for construct week Project Competition
                        </Text>
                        <Text fontSize={"12"} >
                            Ranked 1st in Gruop Projects...
                            Gym.com  Duration : 4-5 days
                        </Text>
                        <Image src={first} my="5" w="100%" h="100px" objectFit={"cover"} alt="" />
                    </Flex>
                </SimpleGrid>
            </Container>
        </Box>
    )
}


function Tilt1(props) {
    const { options, Theme } = props;
    const tilt = React.useRef(null);

    useEffect(() => {
        VanillaTilt.init(tilt.current, options);
    }, [options]);

    return <Box w={"50%"} ref={tilt} m="auto" mt="5" >
        <Text color={Theme === "dark" ? "#fff" : "#000"} fontWeight='bold' mb="20" mt="15" fontSize={["25", "25", "25", "35", "40"]} textAlign={"center"} >
            <Highlight
                query={'Achievements'}
                styles={{ color: `${Theme === "dark" ? "#F2AA4CFF" : "red.400"}` }}
            >
                Personal  Achievements
            </Highlight>
        </Text>
    </Box>
}

export default Acheivements